import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

interface VocabularySearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const VocabularySearch: React.FC<VocabularySearchProps> = ({
  value,
  onChange,
  placeholder = "Search terms, definitions, or context..."
}) => {
  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg leading-5 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:focus:ring-indigo-400 dark:focus:border-indigo-400 transition-colors duration-200"
        placeholder={placeholder}
      />
    </div>
  );
};

export default VocabularySearch;
